"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsProductionOrderTable = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DmsButtonGroup = require("../DmsButtonGroup/DmsButtonGroup");
var _DmsPermissions = require("../DmsPermissions/DmsPermissions");
var _DmsTable = require("../DmsTable/DmsTable");
var _DmsTableCreateButton = require("../DmsTableButton/DmsTableCreateButton");
var _DmsTableEditButton = require("../DmsTableButton/DmsTableEditButton");
var _DmsTableDeleteButton = require("../DmsTableButton/DmsTableDeleteButton");
var _DmsFlexContainer = require("../DmsFlexContainer/DmsFlexContainer");
var _Permissions = require("../../constants/Permissions");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsProductionOrderStatusRectangle = require("./DmsProductionOrderStatusRectangle");
var _ProductionOrderStatus = require("../../constants/ProductionOrderStatus");
var _moment = _interopRequireDefault(require("moment"));
var _DateTimeFormats = require("../../constants/DateTimeFormats");
var _DmsBatchModal = require("./DmsProductionOrderBatch/DmsBatchModal");
var _DmsStationModal = require("./DmsProductionOrderStation/DmsStationModal");
var _DmsExport = require("../DmsExport/DmsExport");
var _material = require("@mui/material");
var _Inventory2Outlined = _interopRequireDefault(require("@mui/icons-material/Inventory2Outlined"));
var _Dock = _interopRequireDefault(require("@mui/icons-material/Dock"));
var _DmsButtonStation = _interopRequireDefault(require("./DmsProductionOrderStation/DmsButtonStation"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * DmsProductionOrderTable.
 * Renders a DmsTable with production order datas
 * @component
 * @example
 * return (
 *   <DmsProductionOrderTable />
 * )
 */

const DmsProductionOrderTable = () => {
  const table = (0, _react.useRef)(null);
  const [showModalBatch, setShowModalBatch] = (0, _react.useState)(false);
  const [showModalStation, setShowModalStation] = (0, _react.useState)(false);
  const [selectedRowData, setSelectedRowData] = (0, _react.useState)("");
  const handleShowBatchModal = row => {
    setSelectedRowData(row);
    setShowModalBatch(true);
  };
  const handleShowStationModal = row => {
    setSelectedRowData(row);
    setShowModalStation(true);
  };
  const handleHideModalAndUpdateTable = () => {
    setShowModalStation(false);
    if (table && table.current) {
      table.current.updateTable();
    }
  };
  const header = [{
    label: _reactIntlUniversal.default.get("OrderNumber").d("Order number"),
    column_name: "order_number",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("ScheduledTo").d("Scheduled to"),
    column_name: "scheduled_to",
    filter: true,
    sortable: true,
    function: date => (0, _moment.default)(date).format(_DateTimeFormats.DATE_TIME_FORMATS.DAY_MONTH_YEAR_HOUR_MINUTE),
    control: 'datetime',
    disableManualInput: true
  }, {
    label: _reactIntlUniversal.default.get("Status").d("Status"),
    column_name: "status",
    map: {
      [_ProductionOrderStatus.ProductionOrderStatus.PAUSED]: /*#__PURE__*/_react.default.createElement(_DmsProductionOrderStatusRectangle.DmsProductionOrderStatusRectangle, {
        status: _ProductionOrderStatus.ProductionOrderStatus.PAUSED
      }),
      [_ProductionOrderStatus.ProductionOrderStatus.CREATED]: /*#__PURE__*/_react.default.createElement(_DmsProductionOrderStatusRectangle.DmsProductionOrderStatusRectangle, {
        status: _ProductionOrderStatus.ProductionOrderStatus.CREATED
      }),
      [_ProductionOrderStatus.ProductionOrderStatus.PRODUCTION]: /*#__PURE__*/_react.default.createElement(_DmsProductionOrderStatusRectangle.DmsProductionOrderStatusRectangle, {
        status: _ProductionOrderStatus.ProductionOrderStatus.PRODUCTION
      }),
      [_ProductionOrderStatus.ProductionOrderStatus.FINISHED_OK]: /*#__PURE__*/_react.default.createElement(_DmsProductionOrderStatusRectangle.DmsProductionOrderStatusRectangle, {
        status: _ProductionOrderStatus.ProductionOrderStatus.FINISHED_OK
      }),
      [_ProductionOrderStatus.ProductionOrderStatus.FINISHED_NOK]: /*#__PURE__*/_react.default.createElement(_DmsProductionOrderStatusRectangle.DmsProductionOrderStatusRectangle, {
        status: _ProductionOrderStatus.ProductionOrderStatus.FINISHED_NOK
      }),
      [_ProductionOrderStatus.ProductionOrderStatus.SHIPPED]: /*#__PURE__*/_react.default.createElement(_DmsProductionOrderStatusRectangle.DmsProductionOrderStatusRectangle, {
        status: _ProductionOrderStatus.ProductionOrderStatus.SHIPPED
      }),
      [_ProductionOrderStatus.ProductionOrderStatus.CANCELLED]: /*#__PURE__*/_react.default.createElement(_DmsProductionOrderStatusRectangle.DmsProductionOrderStatusRectangle, {
        status: _ProductionOrderStatus.ProductionOrderStatus.CANCELLED
      })
    },
    control: 'select',
    filter: true,
    sortable: false,
    can_create: false,
    can_edit: false
  }, {
    label: _reactIntlUniversal.default.get("Batches").d("Batches"),
    column_name: "pk",
    width: "5vw",
    sortable: false,
    can_create: false,
    can_edit: false,
    element: row => /*#__PURE__*/_react.default.createElement(_material.Chip, {
      label: _reactIntlUniversal.default.get("Batches").d("Batches"),
      onClick: () => handleShowBatchModal(row),
      icon: /*#__PURE__*/_react.default.createElement(_Inventory2Outlined.default, {
        sx: {
          color: "#FFFFFF !important"
        }
      }),
      sx: {
        minWidth: "8vw",
        color: "#FFFFFF",
        backgroundColor: "#4682B4",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
        ":hover": {
          backgroundColor: "#5A9BD4"
        }
      }
    })
  }, {
    label: _reactIntlUniversal.default.get("Station").d("Station"),
    column_name: "pk",
    width: "5vw",
    sortable: false,
    can_create: false,
    can_edit: false,
    element: row => /*#__PURE__*/_react.default.createElement(_DmsButtonStation.default, {
      row: row,
      handleShowStationModal: handleShowStationModal
    })
  }, {
    label: _reactIntlUniversal.default.get("Actions").d("Actions"),
    width: "5vw",
    sortable: false,
    element: row => {
      const order_number = row.order_number;
      return /*#__PURE__*/_react.default.createElement(_DmsButtonGroup.DmsButtonGroup, null, /*#__PURE__*/_react.default.createElement(_DmsTableEditButton.DmsTableEditButton, {
        table: table,
        title: _reactIntlUniversal.default.get("UpdateProductionOrder", {
          order_number
        }).d("Update production order {order_number}"),
        url: "/production_order",
        row: row
      }), /*#__PURE__*/_react.default.createElement(_DmsTableDeleteButton.DmsTableDeleteButton, {
        table: table,
        title: _reactIntlUniversal.default.get("DeleteProductionOrder", {
          order_number
        }).d("Delete production order {order_number}"),
        text: _reactIntlUniversal.default.get("ProductionOrder.DeleteMensage", {
          order_number
        }).d("Delete production order with order number {order_number}. Are you sure about it?"),
        url: "/production_order",
        row_pk: row.pk
      }));
    }
  }];
  const toolbar = /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer, null, /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer.Left, null, /*#__PURE__*/_react.default.createElement(_DmsPermissions.DmsPermissions, {
    permissions: _Permissions.Permissions.CAN_EDIT_PART
  }, /*#__PURE__*/_react.default.createElement(_DmsTableCreateButton.DmsTableCreateButton, {
    table: table,
    title: _reactIntlUniversal.default.get("CreateProductionOrder").d("Create production order"),
    url: "/production_order",
    header: header,
    variant: "primary"
  }))), /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer.Right, null, /*#__PURE__*/_react.default.createElement(_DmsExport.DmsExport, {
    table: table
  })));
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_DmsBatchModal.DmsBatchModal, {
    table: table,
    show: showModalBatch,
    row_data: selectedRowData,
    onHide: () => setShowModalBatch(false)
  }), /*#__PURE__*/_react.default.createElement(_DmsStationModal.DmsStationModal, {
    table: table,
    show: showModalStation,
    row_data: selectedRowData,
    onHide: () => handleHideModalAndUpdateTable()
  }), /*#__PURE__*/_react.default.createElement(_DmsTable.DmsTable, {
    ref: table,
    url: "production_order/table",
    responsive: true,
    header: header,
    needs_authentication: true,
    managed: true,
    toolbar: toolbar
  }));
};
exports.DmsProductionOrderTable = DmsProductionOrderTable;